import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  InstallmentDetailsPageHeader,
  InstallmentDetailsTable,
} from "./components";

import { getInstallmentDetails } from "@api/gpf";

import {
  InstallmentDetailsResponseTypes,
  InstallmentDetailsTypes,
} from "@type/HRM/gpf";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const InstallmentDetails = () => {
  const { id, id2 } = useParams();
  const [installmentDetails, setInstallmentDetails] =
    useState<InstallmentDetailsResponseTypes>();

  useEffect(() => {
    getInstallmentDetails(id, id2)
      .then((data) => {
        setInstallmentDetails(data.data);
      })
      .catch((err) => console.log(err));
  }, [id, id2]);

  return (
    <div className="p-10">
      <InstallmentDetailsPageHeader
        employee={installmentDetails?.employee as EmployeeCommonInfoType}
      />
      <div className="py-10">
        <InstallmentDetailsTable
          id={id}
          loanID={id2}
          installmentDetails={
            installmentDetails?.installments as InstallmentDetailsTypes[]
          }
          isFullyPaid={installmentDetails?.isFullyPaid || false}
        />
      </div>
    </div>
  );
};

export default InstallmentDetails;
